<template>
  <div class="dashboard">
    <div class="metrics" v-if="metrics">
      <KPICard
        :title="onlineAudiologists"
        :subtitle="$t('evocall.dashboard.online_audiologists')"
      >
        <template slot="description" v-if="audiologistsInBreak > 0">
          <span class="text-default-color"> {{`${$t('evocall.dashboard.audiologists_in_break')}: ${audiologistsInBreak}`}} </span>
        </template>
      </KPICard>

      <KPICard
        :title="metrics.ongoingCalls"
        :subtitle="$t('evocall.dashboard.on_going')"
      >
        <template slot="description">
          <span>
            {{ $t('evocall.dashboard.average_call_duration') }}
          </span>
          <span>
            {{ getRelativeTimeString(metrics.averageCallDuration) }}
          </span>
        </template>
      </KPICard>

      <KPICard
        :title="requests.length"
        :subtitle="$t('evocall.dashboard.waiting_time')"
      >
        <template slot="description">
          <span>
            {{ $t('evocall.dashboard.average_waiting_time') }}
          </span>
          <span>
            {{ getRelativeTimeString(metrics.averageWaitingTime) }}
          </span>
        </template>
      </KPICard>

      <KPICard
        id="priorities-card"
        :title="numberRequestsByPriority.high"
        :subtitle="$t('evocall.dashboard.priority')"
      >
        <template slot="description">

          <div class="card__container__main__description--high">
            <i class="fa fa-angle-up"></i>&nbsp;
            <span class="content">{{ highPriorityPercentage }} %</span>
          </div>
          <div class="card__container__main__description--normal">
            <i class="fa fa-minus"></i>&nbsp;
            <span class="content"> {{ normalPriorityPercentage }} %</span>
          </div>
          <div class="card__container__main__description--low">
            <i class="fa fa-angle-down"></i>&nbsp;
            <span class="content"> {{ lowPriorityPercentage }} %</span>
          </div>
        </template>
      </KPICard>

    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import RelativeTimeMixin from '@/mixins/RelativeTimeMixin'
import KPICard from '@/components/common/KPICard'
export default {
  props: {
    waitingRoomModuleKey: {
      type: String,
      required: true
    },
  },
  components: {
    KPICard
  },
  mixins: [
    RelativeTimeMixin
  ],
  created () {
    this.$store.dispatch(`${this.waitingRoomModuleKey}/GET_METRICS`)
  },
  computed: {
    ...mapState({
      metrics (state, getters) {
        return getters[`${this.waitingRoomModuleKey}/metrics`] || null
      },
      requests (state, getters) {
        return getters[`${this.waitingRoomModuleKey}/requests`] || null
      },
      numberRequestsByPriority (state, getters) {
        return getters[`${this.waitingRoomModuleKey}/numberRequestsByPriority`] || null
      },
      onlineAudiologistsByEntity (state, getters) {
        return getters[`${this.waitingRoomModuleKey}/onlineAudiologistsByEntity`] || null
      }
    }),
    onlineAudiologists: function (value) {
      if (Array.isArray(this.onlineAudiologistsByEntity) && this.onlineAudiologistsByEntity.length > 0) {
        return this.onlineAudiologistsByEntity
          .filter(obj => obj.hasOwnProperty('onlineAudiologists'))
          .reduce((a, b) => { return a + b.onlineAudiologists }, 0)
      }
      return 0
    },
    audiologistsInBreak: function () {
      if (Array.isArray(this.onlineAudiologistsByEntity) && this.onlineAudiologistsByEntity.length > 0) {
        return this.onlineAudiologistsByEntity
          .filter(obj => obj.hasOwnProperty('audiologistsInBreak'))
          .reduce((a, b) => { return a + b.audiologistsInBreak }, 0)
      }
      return 0
    },
    highPriorityPercentage: function () {
      if (!this.requests.length || !this.numberRequestsByPriority.high) {
        return 0
      }
      return Math.round((this.numberRequestsByPriority.high / this.requests.length) * 100)
    },
    normalPriorityPercentage: function () {
      if (!this.requests.length || !this.numberRequestsByPriority.normal) {
        return 0
      }
      return Math.round((this.numberRequestsByPriority.normal / this.requests.length) * 100)
    },
    lowPriorityPercentage: function () {
      if (!this.requests.length || !this.numberRequestsByPriority.low) {
        return 0
      }
      return Math.round((this.numberRequestsByPriority.low / this.requests.length) * 100)
    }
  }
}
</script>

<style lang="scss">

@mixin for-desktop {
  @media (min-width: 766px) {
    @content;
  }
}

@mixin for-desktop-xl {
  @media (min-width: 1336px) {
    @content;
  }
}

$primary-light-gray: #6E6E6E;
$primary-red: #c42940;
$primary-yellow: #c49d29;
$primary-green: #29c4aa;

.dashboard {

  .metrics {

    display: flex;
    flex-direction: column;
    align-items: stretch;

    @include for-desktop {
      flex-direction: row;
      justify-content: space-around;
    }

    .kpi-card {
      width: 100%;

      @include for-desktop {
        width: 21.5%;
      }

      &#priorities-card .card__container__main__description {
        flex-direction: row;

        & span.content {
          font-size: 0.825rem;
          color: $primary-light-gray;
        }
        &--high {
          & i {
            font-size: 1.3rem;
            color: $primary-red;
          }
        }

        &--normal {
          & i {
            font-size: 1rem;
            color: $primary-yellow;
          }
        }

        &--low {
          & i {
            font-size: 1.3rem;
            color: $primary-green;
          }
        }

      }
    }
  }
}
</style>
